import {
  AddCircle,
  FastForward,
  LocalHospital,
  LowPriority,
  Pageview,
  PlaylistAddCheck,
  SwapHorizontalCircle,
} from '@mui/icons-material'
import { tsMenuItem } from '../../Typescript/UI_Interfaces'
import { useSampleRunItems } from './SampleRunSubMenu'
import { useMemo } from 'react'
import { useStuartGet } from '../../APIs/Hooks/PhpAPIHooks'
import { useHoldingContext } from '../../Contexts/CurrentHolding'

export function useSampleMenuItems() {
  const { currentHolding } = useHoldingContext()
  const screensQuery = useStuartGet([
    '/screen/getScreensForHolding.php',
    `?HoldingID=${currentHolding.value}`,
  ])
  const sampleRunsItems = useSampleRunItems()
  return useMemo(() => {
    return [
      {
        path: '/stuart/sample/collect',
        primaryText: 'Collect Samples',
        secondaryText: 'Create a new sample run',
        leftIcon: <PlaylistAddCheck />,
      },
      {
        primaryText: 'Continue Run',
        secondaryText: 'Continue an existing incomplete sample run',
        leftIcon: <FastForward />,
        path: '/stuart/sample/run/',
        nestedItems: sampleRunsItems,
      },
      {
        path: '/stuart/sample/find',
        primaryText: 'Find Sample',
        secondaryText: "Find a sample - it's location, status, destination",
        leftIcon: <Pageview />,
      },
      {
        primaryText: 'Manage Vessels',
        secondaryText: 'View and manage vessels containing samples',
        path: '/stuart/sample/vessel/create',
        leftIcon: <LowPriority />,
        nestedItems: [
          {
            path: '/stuart/sample/vessel/create',
            primaryText: 'Create Vessel',
            leftIcon: <AddCircle />,
          },
          {
            path: '/stuart/sample/vessel/select',
            primaryText: 'View Vessel',
            leftIcon: <Pageview />,
          },
          {
            path: '/stuart/sample/vessel/swap',
            primaryText: 'Swap Vessel Mode',
            leftIcon: <SwapHorizontalCircle />,
          },
        ],
      },
      {
        primaryText: 'Health Screening',
        secondaryText: 'Create, Complete, and Manage Screens',
        path: '/stuart/health/complete',
        leftIcon: <LocalHospital />,
        badgeCount: screensQuery.data?.Screens?.length,
      },
    ] as tsMenuItem[]
  }, [sampleRunsItems, screensQuery.data?.Screens])
}
